import { Controller } from "stimulus"
import { dynamicContentLoaded } from '../../helpers/dynamic-content'
import { showTarget, hideTarget } from '../../helpers/visibility'
import packageMetaFor from '../../helpers/package-meta'
import normalize from 'json-api-normalizer'

const CUSTOM_EVENT_NAME = "stimulus-video-play-audio"

export default class extends Controller {
  static targets = [
    "quickbooksEnableAutomaticSync",
    "quickbooksAutomaticSyncSettings",
    "quickbooksBookings",
    "quickbooksProposals",
    "quickbooksPayments",
    "customizeForBrand",
    "globalCustomFields",
    "brandCustomFields"
  ]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    if(this.hasQuickbooksEnableAutomaticSyncTarget) {
      this.updateQuickbooksSyncTypeVisibility()
    }
    if(this.hasCustomizeForBrandTarget) {
      this.updateCustomizeForBrandVisibility()
    }
  }

  updateQuickbooksSyncTypeVisibility() {
    const quickbooksEnableAutomaticSync = this.quickbooksEnableAutomaticSyncTarget.checked

    if(quickbooksEnableAutomaticSync) {
      showTarget(this.quickbooksAutomaticSyncSettingsTarget)

      const quickbooksBookings = this.quickbooksBookingsTarget.checked
      const quickbooksProposals = this.quickbooksProposalsTarget.checked
      if(quickbooksBookings || quickbooksProposals) {
        this.quickbooksPaymentsTarget.checked = true
        this.quickbooksPaymentsTarget.disabled = true
      }
      else {
        this.quickbooksPaymentsTarget.disabled = false
      }
    }
    else {
      hideTarget(this.quickbooksAutomaticSyncSettingsTarget)
    }


  }

  updateCustomizeForBrandVisibility() {
    const customizeForBrand = this.customizeForBrandTarget.checked
    if(customizeForBrand) {
      showTarget(this.brandCustomFieldsTarget)
      hideTarget(this.globalCustomFieldsTarget)
    } else {
      hideTarget(this.brandCustomFieldsTarget)
      showTarget(this.globalCustomFieldsTarget)
    }
  }
}
